<div class="container-fluid contentHeight renaultmail">
    <h1 class="text-center containerTitle"> Comptes clients Ixell - Informations référents techniques </h1>
    <div class="tableSize row mx-auto">
        <table class="table table-bordered table-hover bg-light col-10 mx-auto ">
          <caption></caption>
            <thead>
                <tr class="font-weight-bold">
                    <th scope="col"> Localisation </th>
                    <th scope="col"> Nom </th>
                    <th scope="col"> Mail </th>
                    <th scope="col"> Ville </th>
                    <th scope="col" class="text-center"> Modifier </th>
                    <th scope="col" class="text-center"> Supprimer </th>
                    <th scope="col" class="text-center"> Ajouter </th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td class="bgGrey"></td>
                    <td class="bgGrey"></td>
                    <td class="bgGrey"></td>
                    <td class="bgGrey"></td>
                    <td class="bgGrey"></td>
                    <td class="bgGrey"></td>
                    <td  (click)="displayAddModal()" class="text-center pointer"> <i  aria-hidden="true" class="fal fa-user-plus text-success"></i></td>
                </tr>
                <tr *ngFor="let mail of allMails">
                    <td> {{mail.location}} </td>
                    <td> {{mail.rTname}} </td>
                    <td> {{mail.rTmail}} </td>
                    <td *ngIf="mail.city"> {{mail.city}} </td>
                    <td *ngIf="!mail.city" class="bgGrey"> </td>
                    <td class="text-center pointer" (click)="displayModifyModal(mail.idvalidationMail)"> <i  aria-hidden="true" class="fal fa-user-edit text-primary"></i> </td>
                    <td class="text-center pointer" (click)="displayDeleteModal(mail.idvalidationMail)"> <i  aria-hidden="true" class="far fa-user-times text-danger"></i> </td>
                    <td class="bgGrey"></td>
                </tr>
            </tbody>
        </table>
    </div>
</div>

<!-- Modal de modification -->
<div id="modifyModal" class="modal">
    <div class="modal-content">   
        <span class="text-right mr-2 pointer close" (click)="closeModifyModal();">  <i  aria-hidden="true"  class=" fal fa-times fa-1x5 primaryRed"></i> </span>
        <div class="container">
            <i  aria-hidden="true" class="fal fa-user-edit iconBackground"></i>
            <div class="upperText">
                <h2 class="text-center">Modifier le référent technique </h2>
                <div class="row">
                    <div class="col-11 mx-auto modalFin p-4">
                        <div [formGroup]="valiationMailForm" class="row">
                            <mat-form-field class="col-lg-6">
                                <mat-label>Nom du référent</mat-label>
                                <input matInput type="text" formControlName="rTname" required>
                            </mat-form-field>
                            <mat-form-field class="col-lg-6">
                                <mat-label>Mail du référent</mat-label>
                                <input matInput type="text" formControlName="rTmail" required>
                            </mat-form-field>
                            <mat-form-field class="col-lg-6">
                              <mat-label>Localisation du référent</mat-label>
                              <mat-select formControlName="location" required>
                                <mat-option *ngFor="let country of countries" (click)="selectedCountry()" (change)="selectedCountry()" value="{{country.value}}"> {{country.name}} </mat-option>
                              </mat-select>
                            </mat-form-field>
                            <mat-form-field class="col-lg-6" *ngIf="isFrench">
                              <mat-label>Région du référent</mat-label>
                              <mat-select formControlName="city" required>
                                <mat-option *ngFor="let city of cities" value="{{city.name}}"> {{city.name}} </mat-option>
                              </mat-select>
                            </mat-form-field>
                        </div>
                        <div class="col-12 mt-3 text-center">
                            <button class="btn btn-primary" (click)="modifyRT()"> Modifier </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Modal de suppression -->
<div id="deleteModal" class="modal">
    <div class="modal-content">   
        <span class="text-right mr-2 pointer close" (click)="closeDeleteModal();">  <i  aria-hidden="true"  class=" fal fa-times fa-1x5 primaryRed"></i> </span>
        <div class="container">
            <i  aria-hidden="true" class="fal fa-user-times iconBackground"></i>
            <div class="upperText">
                <h2 class="text-center"> Voulez vous supprimer le référent technique suivant? </h2>
                <div class="row">
                    <div class="col-11 mx-auto modalFin p-4">
                        <div class="row">
                            <div class="col-lg-6">
                                <span class="font-weight-bold"> Adresse e-mail : </span> <br/> {{actualMail}}
                            </div>  
                            <div class="col-lg-6">
                                <span class="font-weight-bold"> Nom/Prénom : </span>  <br/> {{actualName}}
                            </div>
                            <div class="col-lg-6">
                                <span class="font-weight-bold"> Localisation : </span>  <br/> {{actualLocation}}
                            </div>
                            <div *ngIf="errorForm" class="col-12 text-danger text-center"> Le formulaire est incorrect </div>
                            <div class="col-lg-12 text-center mt-3">
                                <button class="btn btn-danger" (click)="deleteRt()"> Supprimer </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


<!-- Modal d'ajout -->
<div id="addModal" class="modal">
    <div class="modal-content">   
        <span class="text-right mr-2 pointer close" (click)="closeAddModal();">  <i  aria-hidden="true"  class=" fal fa-times fa-1x5 primaryRed"></i> </span>
        <div class="container">
            <i  aria-hidden="true" class="fal fa-user-plus iconBackground"></i>
            <div class="upperText">
                <h2 class="text-center"> Ajouter un technicien référent </h2>
                <div class="col-11 mx-auto modalFin p-4">
                    <div [formGroup]="valiationMailForm" class="row">
                        <mat-form-field class="col-lg-6">
                            <mat-label>Nom du référent</mat-label>
                            <input matInput type="text" formControlName="rTname" required>
                        </mat-form-field>
                        <mat-form-field class="col-lg-6">
                            <mat-label>Mail du référent</mat-label>
                            <input matInput type="text" formControlName="rTmail" required>
                        </mat-form-field>
                        <mat-form-field class="col-lg-6">
                          <mat-label>Localisation du référent</mat-label>
                          <mat-select formControlName="location" required>
                            <mat-option *ngFor="let country of countries" (click)="selectedCountry()" (change)="selectedCountry()" value="{{country.value}}"> {{country.name}} </mat-option>
                          </mat-select>
                        </mat-form-field>
                        <mat-form-field class="col-lg-6">
                          <mat-label>Région du référent</mat-label>
                          <mat-select formControlName="city" required>
                            <mat-option *ngFor="let city of cities" value="{{city.name}}"> {{city.name}} </mat-option>
                          </mat-select>
                        </mat-form-field>
                    </div>
                    <div *ngIf="errorForm" class="col-12 text-danger text-center"> Le formulaire est incorrect </div>
                    <div class="col-12 mt-3 text-center">
                        <button class="btn btn-success" (click)="addRT()"> Enregistrer </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
